

const projectdata = [
    {
        "id": 1,
        "projectName": "ToDo List", 
        "projectDescription": "This Project is Todo List for daily purpose task. In this project we are using local storage when we refresh the page so our does not vanish.",
        "projectLink":"https://todo.thecodesphere.in/",
        "projectRole": "FullStack Developer",
        "TechStack": "React with Vite Tool, React-icons, TailWind css with React.",
        "Features": "Using the Local Storage to prevent the vanishing our data.",
    },
    {
        "id": 2,
        "projectName": "TicTaCToe Game",
        "projectDescription": "This is the TicTacToe Game. This is created on ReactJS Technology.",
        "projectLink":"https://tictactoe.thecodesphere.in/"
    }    
]

export default projectdata;